module.exports = __webpack_public_path__ + "img/antes_despues_269.87b69cc1.png";